import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Menu extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {
        menu: [
          {
            item: "",
            slug: ""
          }
        ]
      },
      'showMenu': {},
      'windowWidth': window.innerWidth
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this));
    fetch('/api/menu').then(res => res.json()).then(json => {
      this.setState({data: JSON.parse(json)});
    });

  }

  /*

      const listItems = this.state.data.item.map((item, index) =>
      <div className="menuItemContainer" key={index}>

      {index === 0 ? "" : <i className="separator">l</i>}

        <Link to={item}>{item}</Link>

      </div>

      );

    */
  handleResize() {

    if (window.innerWidth > 825) {
      this.setState({'showMenu': {}});
    }

  }

  _onMenuClick() {

    switch (this.state.showMenu.display) {
      case "block":

        this.setState({
          'showMenu': {
            display: "none"
          }
        });

        break;
      default:
        this.setState({
          'showMenu': {
            display: "block"
          }
        });
    }

  }
  _onMenuItemClick() {

    if (window.innerWidth < 825) {
      this.setState({
        'showMenu': {
          display: "none"
        }
      });
    }

  }

  render() {

    const listItems = this.state.data.menu.map((item, index) => <div className="menuItemContainer" key={index}>

      {
        index === 0
          ? ""
          : <i className="separator">l</i>
      }

      <Link to={item.slug} onClick={this._onMenuItemClick.bind(this)}>{item.item}</Link>

    </div>);

    return (<div className="navbarContainer">
      <div className="menuMobileButton" onClick={this._onMenuClick.bind(this)}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      <div className="navbarItems" style={this.state.showMenu}>
        {listItems}
      </div>
    </div>);
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu.js